module.exports = __webpack_public_path__ + "img/inspiring_background_mobile.504d348.webp";